import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { RootState } from "../../store";
import { User } from "../../services/users-api/types";
import { LoginResponse } from "../../services/auth-api/types";
import { usersApi } from "../../services/users-api/users-api";
import { authApi } from "../../services/auth-api/auth-api";

export type AuthState = {
  user: User | null;
  token: string | null;
  refreshToken: string | null;
};

const token = localStorage.getItem("token");
const refreshToken = localStorage.getItem("refreshToken");

const authSlice = createSlice({
  name: "auth",
  initialState: {
    token,
    refreshToken,
  } as AuthState,
  reducers: {
    setToken: (
      state,
      { payload: { accessToken, refreshToken } }: PayloadAction<LoginResponse>
    ) => {
      state.token = accessToken;
      state.refreshToken = refreshToken;

      localStorage.setItem("token", accessToken);
      localStorage.setItem("refreshToken", refreshToken);
    },
    setUser: (state, { payload: user }: PayloadAction<User>) => {
      state.user = user;
    },
    logout: (state) => {
      localStorage.removeItem("user");
      localStorage.removeItem("token");
      localStorage.removeItem("refreshToken");

      state.user = null;
      state.token = null;
      state.refreshToken = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addMatcher(
        usersApi.endpoints.getCurrentUser.matchFulfilled,
        (state, { payload: user }) => {
          state.user = user;
        }
      )
      .addMatcher(
        authApi.endpoints.exchangeToken.matchFulfilled,
        (state, { payload: { accessToken, refreshToken } }) => {
          state.token = accessToken;
          state.refreshToken = refreshToken;

          localStorage.setItem("token", accessToken);
          localStorage.setItem("refreshToken", refreshToken);
        }
      );
  },
});

const { actions, reducer } = authSlice;

export const { setToken, logout } = actions;

export default reducer;

export const isAuthorized = (state: RootState) => state.auth.token;
export const currentUser = (state: RootState) => state.auth.user;
